import { render } from "./IconMenu.vue?vue&type=template&id=6ff6ea94"
import script from "./IconMenu.vue?vue&type=script&lang=js"
export * from "./IconMenu.vue?vue&type=script&lang=js"
script.render = render

export default script